import { createTheme, ThemeOptions } from '@mui/material'
import { colors, TopBaseTheme } from '.'

const { typography, ...TopResumeThemeWithoutTypography } = TopBaseTheme

// base theme, used to be able to access breakpoints in final theme
const base = createTheme(TopResumeThemeWithoutTypography, {
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
      mobile: 375,
      tablet: 1024,
      laptop: 1024,
      desktop: 1440,
    },
  },
})

export const TopLandingTheme = createTheme(base, {
  typography: {
    fontFamily: 'tt-talent',
    fontSize: 19,
    fontWeightRegular: 400,
    allVariants: {
      color: colors.neutral[90],
    },
    h1: {
      fontFamily: 'tt-talent',
      fontWeight: 'normal',
      fontSize: 34,
      lineHeight: '36px',

      [base.breakpoints.up('mobile')]: {
        fontSize: 46,
        lineHeight: '48px',
      },

      [base.breakpoints.up('tablet')]: {
        fontSize: 54,
        lineHeight: '54px',
      },
    },
    h2: {
      fontFamily: 'tt-talent',
      fontWeight: 'normal',
      fontSize: 28,
      lineHeight: '32px',

      [base.breakpoints.up('mobile')]: {
        fontSize: 36,
        lineHeight: '36px',
      },

      [base.breakpoints.up('tablet')]: {
        fontSize: 43,
        lineHeight: '43px',
      },
    },
    h3: {
      fontFamily: 'tt-talent',
      fontWeight: 'normal',
      fontSize: 20,
      lineHeight: '24px',

      [base.breakpoints.up('mobile')]: {
        fontSize: 21,
        lineHeight: '26px',
      },

      [base.breakpoints.up('tablet')]: {
        fontSize: 23,
        lineHeight: '28px',
      },
    },
    h4: {
      fontWeight: '500 !important',
      fontSize: '19px !important',
      lineHeight: '24px !important',
      fontFamily: 'tt-talent !important',
      [base.breakpoints.up("mobile")]: {
        fontSize: 20,
        lineHeight: "26px",
      },

      [base.breakpoints.up("tablet")]: {
        fontSize: 20,
        lineHeight: "28px",
      },
    },
    h5: {
      fontWeight: "500 !important",
      fontSize: "17px !important",
      lineHeight: "26px !important",
      fontFamily: "tt-talent !important",
    },
    h6: {
      fontWeight: "500 !important",
      fontSize: "14px !important",
      lineHeight: "20px !important",
      fontFamily: "tt-talent !important",
    },
    body1: {
      fontFamily: 'tt-talent',
      fontWeight: 'normal',
      fontSize: 18,
      lineHeight: '22px',

      [base.breakpoints.up('mobile')]: {
        fontSize: 18,
        lineHeight: '22px',
      },

      [base.breakpoints.up('tablet')]: {
        fontSize: 19,
        lineHeight: '24px',
      },
    },
    button: {
      fontFamily: 'tt-talent',
      fontWeight: 'normal',
      fontSize: 18,
      lineHeight: '22px',

      [base.breakpoints.up('mobile')]: {
        fontSize: 18,
        lineHeight: '22px',
      },

      [base.breakpoints.up('tablet')]: {
        fontSize: 19,
        lineHeight: '24px',
      },
    },
    caption: {
      fontFamily: 'proxima-nova, Helvetica, Arial, sans-serif',
      fontSize: '.88rem',
      lineHeight: '1.57',
    },
    overline: {
      color: colors.blue[400],
      fontFamily: 'proxima-nova, Helvetica, Arial, sans-serif',
      fontSize: '.88rem',
      fontWeight: 700,
      letterSpacing: '.07em',
      lineHeight: '1.4',
      textTransform: 'uppercase',
      '@media (max-width:600px)': {
        fontSize: '.88rem',
        lineHeight: '1.4',
      },
    },
  },
} satisfies ThemeOptions)
